import React, { useState, useContext, useEffect } from "react";
import Application from "../../../StateContext/Application";
import { usePDF } from 'react-to-pdf';
import { CSVLink } from "react-csv";
const OpenTenders = () => {
    const statecalls = useContext(Application);
    const { GetOpenTenders } = statecalls;
    const [displaytenders, setDisplayTenders] = useState([]);
    const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(1);
    const [CSVDATA,SetCSVDATA]=useState([])
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = displaytenders.slice(indexOfFirstItem, indexOfLastItem);

    var csv = [
        ["Tender Name", "PO Number", "Description", "Tender Opening Date", "Tender Closing Date", "GST", "Ernest Money Deposit", "Tender Fee", "Registrations"]
    ]

    useEffect((e) => {
        ShowOpenTenders()
    }, [])

    async function ShowOpenTenders() {
        try {
            let data = await GetOpenTenders()
            setDisplayTenders(data)
        } catch (error) {
            console.error(error);
        }
    }

    const upload = new FormData();

    const Savefile = async () => {
        try {
            displaytenders.forEach((x) => {
                csv.push([x.Tender_Name,x.PO_Number,x.Description,x.Tender_Opening_Date,x.Tender_Closing_Date,x.GST,x.ErnestMoneyDeposit,x.TenderFee,x.registertion_count])
            })
            SetCSVDATA(csv);
        } catch (error) {
            console.error('Error saving file:', error);
        }
    }

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            <div style={{ padding: "50px" }}>
            <CSVLink data={CSVDATA} target="blank"  onClick={Savefile} className='my-3 btn btn-primary'> Download Excel</CSVLink> 
                <button onClick={() => { toPDF() }} className='my-3 mx-2 btn btn-success'>Download PDF</button>
                <table className="table table-bordered" ref={targetRef}>
                    <thead>
                        <tr>
                            <th>Sr.no.</th>
                            <th>Scheme Name</th>
                            <th>PO Number</th>
                            <th>Description</th>
                            <th>Scheme Opening Date</th>
                            <th>Scheme Closing Date</th>
                            <th>GST</th>
                            <th>Ernest Money Deposite</th>
                            <th>Scheme Fee</th>
                            <th>Registrations</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            displaytenders && currentItems.map((e,index) => {
                                return (
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>{e.Tender_Name}</td>
                                        <td>{e.PO_Number}</td>
                                        <td>{e.Description}</td>
                                        <td>{e.Tender_Opening_Date}</td>
                                        <td>{e.Tender_Closing_Date}</td>
                                        <td>{e.GST}</td>
                                        <td>{e.ErnestMoneyDeposit}</td>
                                        <td>{e.TenderFee}</td>
                                        <td>{e.registertion_count}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <ul className="pagination">
                        {Array(Math.ceil(displaytenders.length / itemsPerPage))
                            .fill()
                            .map((_, index) => (
                                <li key={index} className="page-item">
                                    <button onClick={() => paginate(index + 1)} className="page-link">
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                    </ul>
                </div>
               
               
            </div>
        </>
    )
}

export default OpenTenders;